<template>
    <div class="progress-circle" :data-progress="progress">
        <div class="circle">
            <div class="full progress-circle__slice">
                <div class="progress-circle__fill"></div>
            </div>
            <div class="progress-circle__slice">
                <div class="progress-circle__fill"></div>
                <div class="progress-circle__fill progress-circle__bar"></div>
            </div>
        </div>
        <div class="progress-circle__overlay flex items-center justify-center text-xs">{{ progress }} %</div>
    </div>
</template>

<script>
export default {
    props: ['progress']
};
</script>

<style scoped lang="scss">
$circle-size: 60px;
$circle-background: #dcdffc;
$circle-color: #031837;
$inset-size: 55px;
$inset-color: #fbfbfb;
$transition-length: 1s;

.progress-circle {
    margin: 0px auto;
    width: $circle-size;
    height: $circle-size;

    background-color: $circle-background;
    border-radius: 50%;
    .progress-circle__slice,
    .progress-circle__fill {
        width: $circle-size;
        height: $circle-size;
        position: absolute;
        transition: transform $transition-length;
        border-radius: 50%;
    }
    .progress-circle__slice {
        clip: rect(0px, $circle-size, $circle-size, calc($circle-size/2));
        .progress-circle__fill {
            clip: rect(0px, calc($circle-size/2), $circle-size, 0px);
            background-color: $circle-color;
        }
    }
    .progress-circle__overlay {
        width: $inset-size;
        height: $inset-size;
        position: absolute;
        margin-left: calc(($circle-size - $inset-size) / 2);
        margin-top: calc(($circle-size - $inset-size) / 2);

        background-color: $inset-color;
        border-radius: 50%;
    }

    $i: 0;
    $increment: calc(180deg / 100);
    @while $i <= 100 {
        &[data-progress='#{$i}'] {
            .progress-circle__slice.full,
            .progress-circle__fill {
                transform: rotate($increment * $i);
            }
            .progress-circle__fill.progress-circle__bar {
                transform: rotate($increment * $i * 2);
            }
            $i: $i + 1;
        }
    }
}
</style>
